// Procedural surface textures — the grain, mottle and dapple sheets that every
// world object borrows its detail from. Three small seeded noise canvases baked
// ONCE at scene setup and then sampled for free like any sprite; nothing here
// is a file, and the same seed paints the same texture on every machine, so the
// world never flickers between runs.
//
// Why textures at all, in a game drawn from vector shapes: a flat fill reads as
// "a brown rectangle". The same fill with a whisper of noise over it reads as a
// piece of wood. It is the cheapest handmade-ness there is — one extra sprite.
import { noiseCanvas, type Game } from '../../engine/webgpu.js';

export interface WorldTextures {
  /** Tight speckle — the tooth of sawn timber and quarried stone. */
  grain: number;
  /** Broad soft blotching — sun-bleached plaster, worn earth, weathering. */
  mottle: number;
  /** One soft round puff — a patch of light fallen through leaves. */
  dapple: number;
}

export function bakeWorldTextures(game: Game): WorldTextures {
  return {
    grain: game.assets.frames(noiseCanvas({ size: 128, cell: 5, octaves: 4, seed: 1847, alpha: true })),
    mottle: game.assets.frames(noiseCanvas({ size: 256, cell: 46, octaves: 3, seed: 613, alpha: true })),
    // 'radial' bakes in a circular falloff, so a dapple has no visible quad edge.
    dapple: game.assets.frames(noiseCanvas({ size: 128, cell: 30, octaves: 2, seed: 209, alpha: true, mask: 'radial' })),
  };
}
